import * as Ci from "react-icons/ci";
import * as Fa from "react-icons/fa";
import Accordion from "react-bootstrap/Accordion";
import { RadioButton } from "primereact/radiobutton";
import React, { useRef } from "react";
import { AutoComplete } from "primereact/autocomplete";
import { useState, useEffect } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import Axios from "../../api/Axios";
// import SalesDetailsTable from "../SalesOrderDetails/SalesDetailsTable";
import { useGlobalContext1 } from "../../context/SalesDetailsContext";
import { useGlobalContext } from "../../context/SalesOrderContext";
import storage from "../../Services/Storage";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useReallocateContext } from "../../context/ReallocateContext";
import ReallocateModal from "../ReallocateModal";
import { useManualSOUpdateContext } from "../../context/ManualSOUpdateContext";
import Print from "../InvoicePrint/NewPrintInvoice";
import { Link, useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";

let CartVolume = [];
const MOP_URl = "SalesOrder/GetMOP?";
const WareHouse_URL = "SalesOrder/GetWareHouseData?";
const PayTerm_URL = "SalesOrder/GetPayTerm?";
const GetCust_URL = "SalesOrder/GetCustomer?";
const SalesExicutive_URL = "SalesOrder/GetSalesExecutive?";
const ExchRate_URl = "SalesOrder/GetExchRate?";
const CustInfo_URL = "SalesOrder/GetCustomerInformation?";
const CreditPosition_URL = "SalesOrder/GetCustFinancialInfo?";
const CreditPosition_URL2 = "SalesOrder/GetCustCreditDtlData?";
const GetSegmentCODE_URL = "SalesOrder/GetSegmentCODE?";
const GetSegment_URL = "SalesOrder/GetSegment?";
const GetOEM_IE_URL = "SalesOrder/GetOEM_IE?";
const GetSEGwiseProdDataSOCreation_URL =
    "SalesOrder/GetSEGwiseProdDataSOCreation?";
const GetAllProdScheme_URL = "SalesOrder/GetAllProdScheme?";
const getDefaultWh_URL = "Default/WhDefaultVal?";
const DefaultVal_URL = "Default/DefaultVal?";
const CalculatePrice_URL = "SalesOrder/CalculatePrice?";
const ManualAddToCart_URl = "SalesOrder/ManualAddToCart";
// const GetPayTermDueDate_URL = "SalesOrder/GetPayTermDueDate?";
const GetBranchByWH_URL = "SalesOrder/GetBranchByWH?";
const GetSerieByBranch_URL = "SalesOrder/GetSerieByBranch?";
const GetPrintMessage_URL = "SalesOrder/GetPrintMessage?";
const reallocation = "SalesOrder/ReAllocation";
const GetSegmentDesc_URL = "SalesOrder/GetSegmentDesc?";
const GetGSTN_URL = "SalesOrder/GetGSTN?";
const GetCustomerGeography_URL = "SalesOrder/GetCustomerGeography?";
const GetOEMSEGwiseProdData_URL = "SalesOrder/GetOEMSEGwiseProdData?";
const GetBaseketAddtocart = "SalesOrder/BasketAddToCart";
const PopulateBaseketlist = "SalesOrder/GetBasketList?";
const GetWorkshopres_URL = "SalesOrder/GetWorkshopinfo?";

// /api/SalesOrder/BasketAddToCart
// /api/SalesOrder/GetBasketList
// let prodRow;
let customerId;

function CreateSOOrder() {
    const nav = useNavigate();
    const auth = storage.getLocal("user");
    const { orientation } = useGlobalContext();
    const {
        // invoiceNo,
        salesOrderHdr,
        reasonDetails,
        filteredSalesDetails,
        setCustId,
        setPayload,
        // setFilteredSalesDetails,
        // invoiceCall,
        invoicePopup,
        setSwitchUpdate,
        getSalesOrderDetails,
        cartVal,
        setCartVal,
        custInfo,
        setCustInfo,
        setExchRate,
        setPriceCalculation,
        setSalesOrderDtlpath,
        setPayTermDueDate,
        defWh,
        setDefWh,
        setPrintMessage,
        setRemarks,
        setSerie,
        orderSummary,
        setOrderSummary,
        loading,
        setLoading,
        handleDeletecart,
        customer,
        setCustomer,
        product,
        setProduct,
        addToCart,
        setAddToCart,
        blockInvalidChar,
        manualSOLoader,
        setManualSOLoader,
        currentDate,
        filterRow,
        filterRow1,
        tradeDisc,
        setTradeDisc,
        setCustPONo,
        volume,
        weight,
        setPayTerm,
        // payTerm,
        // MopId,
        setMopId,
    } = useGlobalContext1();
    const {
        setGetWareHouse,
        getWareHouse,
        // autoAllocate,
        getDefaultVal,
    } = useManualSOUpdateContext();
    const {
        handleEdit,
        setPromoCode,
        setModalShow,
        setReallocateLoader,
        setReallocateDetails,
        orderQty,
        setOrderQty,
        releaseQty,
        setReleaseQty,
        setSoDetailsTable,
        defVal,
        setDefVal,
        setManualReallocateBtn,
        prodRow,
        setProdRow,
        suggestedProductList,
        setSuggestedProductList,
        setSelectedSalesDetails,
        setReallocateToggel,
        setSelectRow,
        netvol,
    } = useReallocateContext();
    const [creditDetails, setCreditDetails] = useState([]);
    const [creditDetails2, setCreditDetails2] = useState([]);
    const [custDetails, setCustDetails] = useState([]);
    const [capitals, setCapitals] = useState([]);
    const [capital, setCapital] = useState(0);
    const [getMOP, setGetMOP] = useState([]);
    const [getSalesExecutive, setGetSalesExecutive] = useState([]);
    // const [allCustomers, setAllCustermes] = useState([]);
    const [productList, setProductList] = useState([]);
    const [filterProductList, setFilterProductList] = useState([]);
    // const [reallocloader, setReallocloader] = useState([]);
    const [prodDtl, setProdDtl] = useState([]);
    const [calculatePrice, setCalculatePrice] = useState(0);
    const [isInPartculrSeg, setIsInPartculrSeg] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [showPopUp1, setShowPopUp1] = useState(false);
    const [showPopUpMsg, setShowPopUpMsg] = useState("");
    const [clearProductData, setClearProductData] = useState(false);
    const [clearCustData, setClearCustData] = useState(false);

    //   -------Basket-----------

    const [basketnamesugg, setBasketnamesugg] = useState([]);
    const [onchangebasketname, setOnchangebasketname] = useState("");
    const [basketname, setBasketname] = useState([]);
    const [basketPrice, setBasketPrice] = useState("");
    const [basketQty, setBasketQty] = useState("");

    // product dropdown -----------------------------------

    // const [getCust, setGetCust] = useState([]);
    const [getPayTerm, setGetPayTerm] = useState([]);
    const [capitalSuggestions, setCapitalSuggestions] = useState(null);
    const [kycdisabled, setKycdisabled] = useState(false);


    const [pdtType, setPdtType] = useState("Product");
    const addtocart = () => {
        if (Number(calculatePrice) === 0) {
            toast.error("Product Price is Not Defined", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else {
            ManualAddToCart();
            setSwitchUpdate(false);
            setManualReallocateBtn(false);
            setSuggestedProductList("");
            setProdRow("");
        }
    };
    const handleReset = () => {
        setCartVal("");
        // setCreditDetails("");
        // setCreditDetails2("");
        // setCustDetails("");
        // setCustInfo("");
        // setProductList("");
        setSuggestedProductList("");
        setOnchangebasketname("");
        setOrderSummary("");
        setProdRow("");
        setOrderQty("");
        setReleaseQty("");
        setProduct(false);
        setAddToCart(false);
        setCalculatePrice(0);
        setBasketQty("");
        CartVolume = [];
        // setCapital();
        // setCartVal("");
    };
    const ManualSOData = async () => {
        setPayload(true);
        setLoading(true);
        try {
            setSalesOrderDtlpath(false);
            const mopurl = `${MOP_URl}CICode=${auth.CICode}`;
            const warehouseurl = `${WareHouse_URL}CICode=${auth.CICode}&UserId=${auth.UserId}&CompId=${auth.CompId}`;
            const paytermurl = `${PayTerm_URL}CICode=${auth.CICode}`;
            const custurl = `${GetCust_URL}CompId=${auth.CompId}`;
            const salesexeurl = `${SalesExicutive_URL}CompId=${auth.CompId}`;
            const exchrateurl = `${ExchRate_URl}CICode${auth.CICode}&CurrencyId=${salesOrderHdr.MASK_CURRENCY_ID}&DefinedBy=${auth.DefinedBy}&CurrencyCode="2"`;
            const defaultwhurl = `${getDefaultWh_URL}CompId=${auth.CompId}&defId=3&UserId=${auth.UserId}`;
            const printmessageurl = `${GetPrintMessage_URL}CICode=${auth.CICode}`;
            const printmessageres = await Axios.get(printmessageurl);
            setPrintMessage(printmessageres.data.Table[0].PRINT_DESCRIPTION);
            const mopresponse = await Axios.get(mopurl);
            const warehouseres = await Axios.get(warehouseurl);
            const paytermres = await Axios.get(paytermurl);
            const custdetailsres = await Axios.get(custurl);
            // setAllCustermes(custdetailsres.data);
            const salesexeres = await Axios.get(salesexeurl);
            const exchrateres = await Axios.get(exchrateurl);
            const defaultwhres = await Axios.get(defaultwhurl);
            //   console.log("defaultwhres", defaultwhres);
            const defaultVal_api = `${DefaultVal_URL}CompId=${auth.CompId
            }&defId=${1}`;
            const default_Res = await Axios.get(defaultVal_api);
            const branchbywh_url = `${GetBranchByWH_URL}CICode=${auth.CICode}&strWareHouseId=${defaultwhres.data.Id}`;
            const branchbywh_res = await Axios.get(branchbywh_url);
            //   console.log("branchbywh_res", branchbywh_res.data);
            const serieByBranch_url = `${GetSerieByBranch_URL}CICode=${auth.CICode}&strBranchId=${branchbywh_res.data}`;
            const serieByBranch_res = await Axios.get(serieByBranch_url);
            //   console.log("serieByBranch_res", serieByBranch_res.data);
            setSerie(serieByBranch_res.data);
            setDefVal(default_Res.data);
            setGetMOP(mopresponse.data);
            setGetWareHouse(warehouseres.data);
            setGetPayTerm(paytermres.data);
            setGetSalesExecutive(salesexeres.data);
            setCustDetails(custdetailsres.data);
            setDefWh(defaultwhres.data);
            setExchRate(exchrateres.data);
            //   const custinfourl = `${CustInfo_URL}CICode=${auth.CICode}&strCustId=${}`
            setCapitals(
                custdetailsres.data.map((val) => {
                    return val.NAME;
                })
            );
            setLoading(false);
        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };
    // !  const creditDtl = async () => {

    //  //   const credURL = `${CreditPosition_URL}CICode=${auth.CICode}&strCustId=${credit[0].MASK_CUST_ID}&strTransType=S`;
    //   //  const credURL2 = `${CreditPosition_URL2}CICode=${auth.CICode}&strCustId=${credit[0].MASK_CUST_ID}`;
    //  //   const credres = await Axios.get(credURL);
    //  //   const credres2 = await Axios.get(credURL2);
    //   //  setCreditDetails(credres.data);
    //   //  setCreditDetails2(credres2.data);
    //  // };

    const handleChange = async (e) => {
        setCapital(e.target.value);
        handleReset();
        // debugger;
        // console.log(
        //   "custinfores4",
        //   custDetails.filter((val) => val.NAME == e.target.value)
        // );

        customerId = custDetails.filter((val) => val.NAME == e.target.value);

        if (customerId.length == 0) {
            setCustId(null);
            // setCreditDetails(null);
            // setCreditDetails2(null);
            setCustInfo(null);
            setPayTermDueDate(null);
            setProdDtl(null);
            setProductList(null);
            setCustomer(false);
        } else {
            setCustId(customerId);
            setLoading(true);
            try {
                const custinfourl = `${CustInfo_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const credurl = `${CreditPosition_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}&strTransType=S`;
                const credurl2 = `${CreditPosition_URL2}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const custinfores = await Axios.get(custinfourl);
                const credres = await Axios.get(credurl);
                const credres2 = await Axios.get(credurl2);
                setCreditDetails(credres.data);
                setCreditDetails2(credres2.data);
                // console.log("credit Details ", credres2);
                setCustInfo(custinfores.data.Table);
                setTradeDisc(custinfores?.data?.Table[0]?.MASK_CUST_DOC_DISC ?? 0);
                // const paytermduedateurl = `${GetPayTermDueDate_URL}CICode=${auth.CICode}&strPayTermId=${custinfores?.data?.Table[0].MASK_PAY_TERM_ID}&strDteDate=${currentDate}`;
                // const paytermduedateres = await Axios.get(paytermduedateurl);
                // console.log(
                //     "paytermduedateres",
                //     paytermduedateres.data.Table[0].DUE_DATE
                // );
                // setPayTermDueDate(paytermduedateres.data.Table[0].DUE_DATE);
                setLoading(false);
                // ___________________________________________________________________
                const GetSegmentCODE_api = `${GetSegmentCODE_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const segCodeRes = await Axios.get(GetSegmentCODE_api);
                // console.log("seg000", segCodeRes.data);
                const GetSegment_api = `${GetSegment_URL}CICode=${auth.CICode}&strSegID=${segCodeRes.data}`;
                const getSegementRes = await Axios.get(GetSegment_api);
                // console.log("segcount", getSegementRes);
                // console.log("a00000", customerId);
                const GetSegmentDesc_api = `${GetSegmentDesc_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const segDescRes = await Axios.get(GetSegmentDesc_api);
                // console.log("segmentDescRes ", segDescRes);
                const GetGSTN_api = `${GetGSTN_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const GstnRes = await Axios.get(GetGSTN_api);
                // console.log("GSTNRES ", GstnRes);
                const GetWorkshopinfo_api = `${GetWorkshopres_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const GetWorkshopres = await Axios.get(GetWorkshopinfo_api);
                const GetCustomerGeography_api = `${GetCustomerGeography_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0].MASK_CUST_ID)}`;
                const CustomerGeographyRes = await Axios.get(GetCustomerGeography_api);
                // console.log("GetCustomerGeography Res ", CustomerGeographyRes);
                if (
                    GetWorkshopres?.data &&
                    GetWorkshopres?.data.length > 0 &&
                    (!GetWorkshopres?.data[0]?.OUTLET_ID || GetWorkshopres[0]?.OUTLET_ID.trim() === "")
                ) {
                    setShowPopUpMsg(
                        "Workshop outlet is not mapped for this customer, please contact Workshop Manager to map the outlet."
                    );
                    setShowPopUp(true);
                    setKycdisabled(true);
                    handleReset();
                    return;
                }
                if (customerId[0].CUST_CREDIT_HOLD == "Y") {
                    setShowPopUpMsg(
                        "Credit Hold option should be 'No' in Customer Master Page"
                    );
                    setShowPopUp(true);
                    setKycdisabled(true);
                    handleReset();
                } else if (
                    customerId[0].KYC_STATUS == "R" ||
                    customerId[0].KYC_STATUS == "S"
                ) {
                    toast.error(
                        `KYC Status of the selected customer is ${customerId[0].KYC_STATUS == "R"
                            ? "Rejected"
                            : customerId[0].KYC_STATUS == "S"
                                ? "Billing Stopped"
                                : ""
                        }, kindly get the customer KYC Approved to continue.`,
                        {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 4000,
                        }
                    );
                    setKycdisabled(true);
                    handleReset();
                } else {
                    if (Number(getSegementRes.data) > 0) {
                        const GetOEM_IE_api = `${GetOEM_IE_URL}CICode=${auth.CICode}&strSegID=${segCodeRes.data}`;
                        const oemRes = await Axios.get(GetOEM_IE_api);
                        console.log("oem", oemRes.data);
                        const GetSEGwiseProdDataSOCreation_api = `${GetSEGwiseProdDataSOCreation_URL}CompId=${auth.CompId}&stkwhid=${defWh.Id}`;
                        const getsegwiseRes = await Axios.get(
                            GetSEGwiseProdDataSOCreation_api
                        );
                        setProdDtl(getsegwiseRes.data);
                        // console.log("productList111", getsegwiseRes.data);
                        // console.log(
                        //   "productList1111",
                        //   getsegwiseRes.data.map((val) => {
                        //     return val.DESCRIPTION + "," + val.PROD_BATCH_NO;
                        //   })
                        // );
                        setProductList(
                            getsegwiseRes.data.map((val) => {
                                return (
                                    val.DESCRIPTION +
                                    " , " +
                                    val.PROD_BATCH_NO +
                                    "( ₹ " +
                                    val.PRODUCT_MRP +
                                    ")" +
                                    " , " +
                                    val.STOCK_AVAILABLE
                                );
                            })
                        );
                    } else {
                        const defaultVal_api = `${DefaultVal_URL}CompId=${auth.CompId
                        }&defId=${1}`;

                        let default_Res = await Axios.get(defaultVal_api);
                        // console.log("def000", default_Res.data.Id);
                        // console.log("whid", getWareHouse);
                        // console.log("defwh", defWh.Id);
                        let whfilter = getWareHouse.filter((val) => {
                            return val.MASK_WH_ID == defWh.Id;
                        });
                        // console.log("whfilter", whfilter);
                        // console.log("compid ", auth.CompId);
                        const GetAllProdScheme_api = `${GetAllProdScheme_URL}CICode=${auth.CICode
                        }&DivnId=${default_Res.data.Id}&WhId=${whfilter[0].MASK_WH_ID
                        }&strStockTypeId=${1}&stkwhid=${defWh.Id}&CompId=${auth.CompId}`;
                        const AllProdSchemeRes = await Axios.get(GetAllProdScheme_api);
                        // console.log("elseProduct ", AllProdSchemeRes.data);
                        setProdDtl(AllProdSchemeRes.data);
                        setProductList(
                            AllProdSchemeRes.data.map((val) => {
                                return (
                                    val.DESCRIPTION +
                                    " , " +
                                    val.PROD_BATCH_NO +
                                    "( ₹ " +
                                    val.PRODUCT_MRP +
                                    ")" +
                                    " , " +
                                    val.STOCK_AVAILABLE
                                );
                            })
                        );
                    }
                    basketPopulation();
                    basketPopulation();
                    setCustomer(true);
                    setKycdisabled(false);
                    //   console.log(
                    //     "segDescRes.data[0].SUBSEGMENT_DETAIL_ID segDescRes.data[0].SUBSEGMENT_DETAIL_ID ",
                    //     segDescRes.data[0].SUBSEGMENT_DETAIL_ID
                    //   );

                    if (
                        segDescRes.data[0].SUBSEGMENT_DETAIL_ID == "G_FOA-P06-4" ||
                        segDescRes.data[0].SUBSEGMENT_DETAIL_ID == "G_P06-4" ||
                        segDescRes.data[0].SUBSEGMENT_DETAIL_ID == "G_P05-4" ||
                        segDescRes.data[0].SUBSEGMENT_DETAIL_ID == "G_P07-4"
                    ) {
                        setIsInPartculrSeg(true);
                    }
                    if (GstnRes.data[0]?.GSTN == "") {
                        if (
                            ((auth.DistTag == "I" && !isInPartculrSeg) ||
                                (segDescRes?.data[0]?.channel_id == "B2B" &&
                                    !isInPartculrSeg)) &&
                            CustomerGeographyRes?.data[0]?.GEOG_ID != "EBH"
                        ) {
                            setShowPopUpMsg(
                                "GST No. is not set for this customer.Please set the GST No in the Customer Master to continue billing."
                            );
                            setShowPopUp(true);
                            setKycdisabled(true);
                            handleReset();
                        } else {
                            setShowPopUpMsg(
                                "Please set GST No. for this customer. Customer without GSTN will be considered as B2C for E-Invoicing."
                            );
                            setShowPopUp(true);
                            // setClearCustData(true);
                        }
                    }
                }
            } catch (error) {
                console.log("error", error);
                setLoading(false);
            }
        }
    };

    const footerContent = (
        <div className="text-end">
            <button
                type="button"
                className="btn btn-primary me-3"
                onClick={() => {
                    setShowPopUp1(false);
                    getSalesOrderDetails();
                }}
            >
                Save
            </button>
            <button
                type="button"
                className="btn btn-cancel-red"
                onClick={() => {
                    setShowPopUp1(false);
                }}
            >
                cancel
            </button>
        </div>
    );

    const popUpHandler = () => {
        setShowPopUp(false);
        if (clearProductData) {
            setSuggestedProductList("");
        }
        if (clearCustData) {
            setCapital("");
        }
        setClearCustData(false);
        setClearProductData(false);
    };

    const popUpDialog = () => {
        return (
            <>
                <Dialog
                    header="Confirmation"
                    visible={showPopUp}
                    style={{ width: "50vw" }}
                    closable={false}
                    resizable={false}
                    draggable={false}
                >
                    <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                        <p>{showPopUpMsg}</p>
                    </div>
                    <div className="float-end mt-3">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                                popUpHandler();
                            }}
                        >
                            OK
                        </button>
                    </div>
                </Dialog>
            </>
        );
    };
    const popUpDialogforSave = () => {
        return (
            <>
                <Dialog
                    header="Information"
                    visible={showPopUp1}
                    style={{ width: "40vw" }}
                    closable={false}
                    resizable={false}
                    draggable={false}
                    footer={footerContent}
                >
                    <div className="col-md-12 col-lg-12 col-sm-12 text-center">
                        <p>{showPopUpMsg}</p>
                    </div>
                </Dialog>
            </>
        );
    };

    const basketPopulation = async () => {
        if (auth.BasketApplicability == "Y") {
            try {
                const basketURL = `${PopulateBaseketlist}`;
                let baskres = await Axios.get(basketURL);
                if (baskres?.data?.Data?.length > 0 || baskres.data.Data != null) {
                    setBasketnamesugg(baskres.data.Data);
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const searchBasket = (e) => {
        setTimeout(() => {
            let _filteredemployee;
            if (!e.query.trim().length) {
                _filteredemployee = [...basketnamesugg];
            } else {
                _filteredemployee = basketnamesugg.filter((employee) => {
                    return (
                        employee.BASKET_CODE.toLowerCase().includes(
                            e.query.toLowerCase()
                        ) ||
                        employee.BASKET_NAME.toLowerCase().includes(e.query.toLowerCase())
                    );
                });
            }

            setBasketname(_filteredemployee);
        }, 400);
    };

    const baksetTemplate = (employee) => {
        return (
            <>
                {employee.BASKET_CODE}-{employee.BASKET_NAME}
            </>
        );
    };
    const handleBasketprod = (e) => {
        // console.log("e.target.value",e.target.value)
        setBasketPrice(e?.target?.value?.BASKET_VALUE);
        setOnchangebasketname(e?.target?.value);
        setProduct(true);
    };

    // useEffect(()=>{
    //     if(onchangebasketname==""||onchangebasketname==null){
    //         setProduct(false);
    //     }else{
    //         setProduct(true);
    //     }
    // },[onchangebasketname]);
    const chkbasketaddtocart = (newBasketCode) => {
        if (cartVal.length > 1) {
            const exists = cartVal.some(
                (product) => product.BASKET_CODE === newBasketCode && newBasketCode !== ""
            );
            if (exists) {
                return false;
            }
            return true;
        }
        return true;


    };
    const basketaddtocart = async () => {
        if (onchangebasketname == null || onchangebasketname == "") {
            toast.warn("Please select basket", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
        else if (basketQty == 0 || basketQty == undefined || basketQty == null || basketQty == "0" || basketQty == "") {
            toast.warn("Please enter order quantity", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
        else if (capital) {
            console.log("call add to cart", onchangebasketname);
            console.log(cartVal);
            if (!chkbasketaddtocart(onchangebasketname?.BASKET_CODE)) {
                toast.warn("Basket is already added to cart", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 3000,
                });
                return;
            }
            let basketaddtocart = {
                compId: auth.CompId,
                basketId: onchangebasketname?.ID.toString() ?? "",
                custId: customerId[0].MASK_CUST_ID,
                strDivnId: defVal.Id,
                oemorder: "",
                tradeDiscPer: tradeDisc ? tradeDisc.toString() : "0",
                uom: "2",
                printFormatCode: auth.PrintFormatCode ?? "",
                currencyId: custInfo[0].MASK_CURRENCY_ID,
                currencyCode: "2",
                OrdQty: basketQty.toString()
            };
            setManualSOLoader(true);
            try {
                const res = await Axios.post(
                    GetBaseketAddtocart,
                    JSON.stringify(basketaddtocart),
                    {
                        headers: { "Content-Type": "application/json" },
                    }
                );
                toast.success("Basket successfully added to cart", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setBasketPrice("");
                // console.log("res.data[0]", res.data[0]);
                // console.log("res.data[0]", res.data);
                setCartVal((current) => [...current, ...res.data]);
                CartVolume.push(...res.data);
                setPriceCalculation((current) => [...current, ...res.data]);
                netvol(CartVolume);
                setAddToCart(true);
                setOrderQty("");
                setBasketQty("");
                setReleaseQty("");
                setOrderSummary(true);
                setOnchangebasketname("");
                setProduct(true);
                // setCustomer(true);
            } catch (error) {
                toast.error(`${error?.response?.data?.Message}`, {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 4000,
                });
            } finally {
                setManualSOLoader(false);
            }
        } else {
            toast.warn("Please select customer", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };

    const handleProd = async (e) => {
        // console.log("pdt000", e.target.value);
        // console.log("pdt000", prodDtl[0]?.DESCRIPTION);
        // console.log("pdt000", prodDtl);
        setSuggestedProductList(e.target.value);
        let pdt = prodDtl.filter((val) => {
            return (
                val.DESCRIPTION +
                " , " +
                val.PROD_BATCH_NO +
                "( ₹ " +
                val.PRODUCT_MRP +
                ")" +
                " , " +
                val.STOCK_AVAILABLE ==
                e.target.value
            );
        });
        if (pdt.length !== 0) {
            if (prodDtl) {
                const prodRow1 = prodDtl.filter(
                    (val) =>
                        val.DESCRIPTION +
                        " , " +
                        val.PROD_BATCH_NO +
                        "( ₹ " +
                        val.PRODUCT_MRP +
                        ")" +
                        " , " +
                        val.STOCK_AVAILABLE ==
                        e.target.value
                );
                setProdRow(prodRow1);
                // console.log("prodrow", prodRow1);
                const GetSegmentCODE_api = `${GetSegmentCODE_URL}CICode=${auth.CICode}&strCustId=${encodeURIComponent(customerId[0]?.MASK_CUST_ID)}`;
                const segmentCodeRes = await Axios.get(GetSegmentCODE_api);
                const GetSegment_api = `${GetSegment_URL}CICode=${auth.CICode}&strSegID=${segmentCodeRes.data}`;
                const segmentRes = await Axios.get(GetSegment_api);
                if (segmentRes.data > 0) {
                    const GetOEM_IE_api = `${GetOEM_IE_URL}CICode=${auth.CICode}&strSegID=${segmentCodeRes.data}`;
                    const GetOEM_IERes = await Axios.get(GetOEM_IE_api);
                    const GetOEMSEGwiseProdData_api = `${GetOEMSEGwiseProdData_URL}CICode=${auth.CICode}&strSegID=${segmentCodeRes?.data}&strProdID=${prodRow1[0]?.MASK_PROD_ID}`;
                    const OEMSEGwiseProdDataRes = await Axios.get(
                        GetOEMSEGwiseProdData_api
                    );

                    if (
                        GetOEM_IERes?.data == "I" &&
                        OEMSEGwiseProdDataRes.data.length > 0 &&
                        OEMSEGwiseProdDataRes.data[0].CNT == 0
                    ) {
                        setShowPopUpMsg(
                            "This Product has OEM Restriction, please contact Castrol Administrator."
                        );
                        setShowPopUp(true);
                        setClearProductData(true);
                        setProdRow([]);
                    }
                    if (
                        GetOEM_IERes?.data == "E" &&
                        OEMSEGwiseProdDataRes.data.length > 0 &&
                        OEMSEGwiseProdDataRes.data[0].CNT > 0
                    ) {
                        setShowPopUpMsg(
                            "This Product has OEM Restriction, please contact Castrol Administrator."
                        );
                        setShowPopUp(true);
                        setClearProductData(true);
                        setProdRow([]);
                    }
                }

                const calculatepriceurl = `${CalculatePrice_URL}CICode=${auth.CICode}&strTrans=SO&strCurrDate=${currentDate}&strSuppCustId=${encodeURIComponent(customerId[0]?.MASK_CUST_ID)}&strCurrencyId=${custInfo[0]?.MASK_CURRENCY_ID}&strDivnId=${defVal.Id}&strProdId=${prodRow1[0]?.MASK_PROD_ID}&strDistId=${auth.CompId}&strPriceListId=${prodRow1[0]?.PROD_BATCH_NO}&strUOMType=2&strModTransRate=0&strSalesAreaId=${custInfo[0]?.MASK_SALES_AREA_ID}&strCustShipGeogId=${custInfo[0]?.CSHIP_ADD_GEOG_ID}`;
                try {
                    const calculatepriceres = await Axios.get(calculatepriceurl);
                    //   console.log("calculatepriceres", calculatepriceres.data);
                    setCalculatePrice(calculatepriceres.data.UnitPrice);
                    setProduct(true);
                } catch (error) {
                    console.log(error);
                    setProduct(true);
                    setCalculatePrice(0);
                }
            }
        } else {
            setProdRow("");
        }
    };

    const filterCapitals = function (e) {
        let results = capitals.filter((capital) => {
            return capital.toLowerCase().includes(e.query.toLowerCase());
        });
        // console.log("custinfores3", results);
        setCapitalSuggestions(results);
    };
    const filterProduct = function (e) {
        let results = productList.filter((capital) => {
            return capital.toLowerCase().includes(e.query.toLowerCase());
        });
        // console.log("custinfores3", results);
        setFilterProductList(results);
    };
    const ManualAddToCart = async () => {
        // setLoading(true);
        if (prodRow.length === 0) {
            toast.error("No Product Selected", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else if (Number(prodRow[0].STOCK_AVAILABLE) < Number(orderQty)) {
            toast.error("Stock is not available", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            setOrderQty("");
            setReleaseQty("");
        } else {
            setManualSOLoader(true);
            const obj = {
                CICode: auth.CICode,
                CustId: customerId[0].MASK_CUST_ID,
                UserId: auth.UserId,
                ComboProduct: prodRow[0].MASK_PROD_ID,
                AvailableQty: prodRow[0].STOCK_AVAILABLE.toString(),
                OrderQty: orderQty.toString(),
                ReleaseQty: releaseQty.toString(),
                ProdName: prodRow[0].DESCRIPTION,
                LotNo: prodRow[0].PROD_BATCH_NO,
                CompId: auth.CompId,
                TradeDiscPer: tradeDisc ? tradeDisc.toString() : "0",
                PrintFormatCode: auth.PrintFormatCode,
                UOM: "2",
                strDivnId: defVal.Id,
                CartValue: "Add To Cart",
                StockType: "1",
                OEMORDER: null,
            };
            if (orderQty.length == 0 || orderQty == 0) {
                toast.error("Enter Correct Ordered Quantity", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setManualSOLoader(false);
            } else if (Number(releaseQty) > Number(orderQty)) {
                toast.error("Release Quantity Should Be Less Than Order Quantity", {
                    position: toast.POSITION.TOP_CENTER,
                    pauseOnFocusLoss: false,
                    closeButton: false,
                    autoClose: 2000,
                });
                setManualSOLoader(false);
            }
            // else if (cartVal?.length == 24) {
            //     toast.warn("Items should not exceeds 24 lines", {
            //         position: toast.POSITION.TOP_CENTER,
            //         pauseOnFocusLoss: false,
            //         closeButton: false,
            //         autoClose: 2000,
            //     });
            //     setManualSOLoader(false);
            // }
            else {
                if (cartVal.length !== 0) {
                    if (
                        cartVal.filter(
                            (a) =>
                                a.PRODUCT_CODE + a.PROD_LOT_NO ===
                                prodRow[0].MASK_PROD_ID + prodRow[0].PROD_BATCH_NO
                        ).length === 1
                    ) {
                        toast.error("Product Line already exists", {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        setManualSOLoader(false);
                        setOrderQty("");
                        setReleaseQty("");
                    } else {
                        try {
                            const res = await Axios.post(
                                ManualAddToCart_URl,
                                JSON.stringify(obj),
                                {
                                    headers: { "Content-Type": "application/json" },
                                }
                            );
                            //   console.log("ManualAddToCart", res.data[0]);
                            toast.success("Product successfully added to cart", {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 2000,
                            });
                            setCartVal((current) => [...current, res.data[0]]);
                            CartVolume.push(res.data[0]);
                            setPriceCalculation((current) => [...current, res.data[0]]);
                            netvol(CartVolume);
                            setAddToCart(true);
                            setManualSOLoader(false);
                            setOrderQty("");
                            setReleaseQty("");
                            setOrderSummary(true);
                            setBasketQty("");
                            setOnchangebasketname("");
                        } catch (error) {
                            // console.log("ManualAddToCart1", error.response.data);
                            toast.error(error?.response?.data?.Message, {
                                position: toast.POSITION.TOP_CENTER,
                                pauseOnFocusLoss: false,
                                closeButton: false,
                                autoClose: 2000,
                            });
                            setManualSOLoader(false);
                        }
                    }
                } else {
                    try {
                        const res = await Axios.post(
                            ManualAddToCart_URl,
                            JSON.stringify(obj),
                            {
                                headers: { "Content-Type": "application/json" },
                            }
                        );
                        // console.log("ManualAddToCart", res.data[0]);
                        toast.success("Product successfully added to cart", {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        setCartVal((current) => [...current, res.data[0]]);
                        CartVolume.push(res.data[0]);
                        setPriceCalculation((current) => [...current, res.data[0]]);
                        netvol(CartVolume);
                        setAddToCart(true);
                        setManualSOLoader(false);
                        setOrderQty("");
                        setReleaseQty("");
                        setOrderSummary(true);
                    } catch (error) {
                        // console.log("ManualAddToCart1", error.response.data);
                        toast.error(error?.response?.data?.Message, {
                            position: toast.POSITION.TOP_CENTER,
                            pauseOnFocusLoss: false,
                            closeButton: false,
                            autoClose: 2000,
                        });
                        setManualSOLoader(false);
                    }
                }
            }
        }
    };
    const handleDeletecart1 = (row) => {
        console.log(row, "cartdetails");
        if (row.BASKET_CODE == "" || row.BASKET_CODE == null) {
            handleDeletecart(row);
            const cart = cartVal.filter((productDtl) => {
                return (
                    productDtl.PRODUCT_CODE + productDtl.PROD_LOT_NO !==
                    row.PRODUCT_CODE + row.PROD_LOT_NO
                );
            });
            CartVolume = cart;
            console.log("cart", cart);
            console.log("cart", CartVolume);
        } else {
            toast.warn("Basket can not be modified", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }

        // console.log("CartVolumeafterdelete", CartVolume);
    };

    console.log("weight", weight);
    //   console.log("weight", volume);

    useEffect(() => {
        ManualSOData();
        getDefaultVal();
        setTradeDisc("");
        CartVolume = [];
        setSwitchUpdate(false);
    }, []);

    // console.log("aaaaaaaaa",calculatePrice.length);
    // console.log("SuggestedProductList",suggestedProductList.length);
    // console.log("ppppp",prodDtl);
    const handlemanualreallocate = () => {
        if (Number(calculatePrice) === 0) {
            toast.error("Product Price is Not Defined", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else if (custInfo.length == 0) {
            toast.warn("Please Select Customer", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else if (suggestedProductList.length == 0) {
            toast.warn("Please select a Product", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } else {
            manualReallocate();
            filterRow1();
        }
    };

    const manualReallocate = async () => {
        setReallocateToggel(true);
        setManualReallocateBtn(true);
        setReallocateLoader(true);
        // setReallocloader(true);
        let _soDetailsData = [
            {
                MASK_SODT_ID: null,
                DIVISION: null,
                MASK_PROD_ID: null,
                STOCK_TYPE: null,
                PRODUCT_CODE: null,
                PROD_SMALL_DESC: null,
                PROD_LOT_NO: null,
                PRICE_LIST_NO: null,
                CASE_TYPE: null,
                CDR_DISC: null,
                EUS_DISC_PERC: null,
                EUS_DISC: null,
                CASE_ORD_QTY: null,
                PACK_ORD_QTY: null,
                TOT_ORD_QTY: null,
                PROD_PRICE: null,
                BASE_PRICE: null,
                CASE_REL_QTY: null,
                PACK_REL_QTY: null,
                TOT_REL_QTY: null,
                TOT_INV_QTY: null,
                MASK_PROD_VAL: null,
                MASK_SODT_PROD_STK_TYPE: null,
                MASK_PACK_UOM_CODE: null,
                MASK_TOT_BACK_QTY: null,
                MASK_TOT_DROP_QTY: null,
                MASK_TRADE_DISC: null,
                MASK_VAL_BASE_CRNC: null,
                MASK_SPLCON_TAX: null,
                MASK_TOT_TAX: null,
                MASK_SODT_TOT_VAT: null,
                MASK_CASE_FACTOR: null,
                MASK_STATUS: null,
                UPDATE_COUNT: null,
                MASK_EXPORTED: null,
                MASK_FIRST_ENTERED_BY: null,
                MASK_FIRST_ENTERED_ON: null,
                MASK_LAST_MODIFIED_BY: null,
                MASK_LAST_MODIFIED_ON: null,
                MASK_IUKEY: null,
                MASK_SEQUENCE: null,
                EXTENDED_PRICE: null,
                MASK_SODT_EUS_DISC_PERC_TAG: null,
                MASK_SODT_TRANS_VAL: null,
                MASK_SODT_CDR_DISC_PERC: null,
                MASK_SODT_CDR_DISC_PERC_TAG: null,
                MASK_SODT_PRICE_OR_TAG: null,
                MASK_SODT_UPPER_BAND: null,
                MASK_SODT_LOWER_BAND: null,
                MASK_SODT_PRL_PRICE: null,
                MASK_SOHD_ID: null,
                MASK_DIVN_ID: null,
                MASK_EVAL_BY_LOT_TAG: null,
                MASK_EUS_DISC_APP_TO: null,
                MASK_PRODUCT_MRP: null,
                MASK_TOT_REL_QTY: null,
                MASK_OLD_STK_ONLY: null,
                RBO_REAS_CODE: null,
                STOCK_TYP: null,
                TOT_AVL_QTY: null,
                MASK_UPDATE_COUNT: null,
            },
        ];
        let obj = {
            AddToCart: "Manual",
            CICode: auth.CICode,
            CompId: auth.CompId,
            CustId: customerId[0].MASK_CUST_ID,
            LotNo: prodRow[0].PROD_BATCH_NO,
            OddLotNo: "",
            ComboProduct: prodRow[0].MASK_PROD_ID,
            ProdName: prodRow[0].DESCRIPTION,
            ReleaseQty: releaseQty.toString(),
            ComboOddLotProduct: "",
            OrderQty: orderQty.toString(),
            OddOrderQty: "",
            ReallocateProdId: prodRow[0].MASK_PROD_ID,
            ComboFreeProduct: "",
            OEMORDER: "TATA",
            StockType: "1",
            Tag: "N",
            UserId: auth.UserId,
            PrintFormatCode: auth.PrintFormatCode,
            UOM: "2",
            UOMCode: "EA",
            CurrencyId: custInfo[0].MASK_CURRENCY_ID,
            CurrencyCode: "2",
            strDivnId: defVal.Id,
            SODetailsData: _soDetailsData,
        };
        try {
            const res = await Axios.post(reallocation, JSON.stringify(obj), {
                headers: { "Content-Type": "application/json" },
            });

            //
            if (
                res.data.SODetailsData.PromoCode ===
                "No other promo code is mapped with this base code" ||
                res.data.SODetailsData.PromoCode === null ||
                res.data.SODetailsData.PromoCode === "0"
            ) {
                setPromoCode(res.data.SODetailsData.PromoCode);
            } else {
                setPromoCode(res.data.SODetailsData.PromoCode.split(",").join(", "));
            }
            // setReallocloader(false);
            const obj1 = {
                PACK_ORD_QTY: orderQty.toString(),
                TOT_INV_QTY: "0",
                PRODUCT_CODE: prodRow[0].MASK_PROD_ID,
            };
            setSelectRow(obj1);
            setModalShow(true);
            setReallocateLoader(false);
            const reallocationFilter = res.data.SalesOrder.filter(
                (val) => Number(val.BALANCED_QTY) > 0
            );
            setSelectedSalesDetails(obj);
            //   console.log("SODetailsDataTable", res.data.SODetailsDataTable);
            setSoDetailsTable(res.data.SODetailsDataTable);
            for (let i = 0; i < res.data.SODetailsDataTable.length; i++) {
                setPriceCalculation((current) => [
                    ...current,
                    res.data.SODetailsDataTable[0],
                ]);
            }
            reallocationFilter.sort((a, b) => {
                return b.PACK_REL_QTY - a.PACK_REL_QTY;
            });
            setReallocateDetails(reallocationFilter);
            // setSuggestedProductList("");
            // prodRow = "";
            // setOrderQty("0");
            // setReleaseQty("0");
            // pdtCode = row.PRODUCT_CODE;
            // pdtLot = row.PROD_LOT_NO;
            //   setCartVal((current) =>
            //     current.filter((productDtl) => {
            //       return (
            //         productDtl.PRODUCT_CODE !== row.PRODUCT_CODE &&
            //         productDtl.PROD_LOT_NO !== row.PROD_LOT_NO
            //       );
            //     })
            //   );
        } catch (error) {
            setReallocateLoader(false);
            // setReallocloader(false);
            toast.error(error.response.data.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            console.log("reallocation_res", error);
        }
    };

    //   console.log(auth, "auth");

    const conditionalRowStylesBasket = [
        {
            when: (row) => row.BASKET_CODE !== "",
            style: {
                backgroundColor: "#ebf1ff",
            },
        },
    ];

    const ref = useRef(null);
    const column = [
        // { name: "Basket Code", selector: (row) => row.BASKET_CODE },
        ...(auth.BasketApplicability == "Y"
            ? [{ name: "Basket Code", selector: (row) => row.BASKET_CODE }]
            : []),
        { name: "Product Code", selector: (row) => row.PRODUCT_CODE },
        {
            name: "Product Name",
            selector: (row) => (
                <div
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={row.PROD_SMALL_DESC}
                    style={{ whiteSpace: "normal", padding: "4px 0px" }}
                >
                    {" "}
                    {row.PROD_SMALL_DESC}
                </div>
            ),
        },
        { name: "Lot No", selector: (row) => row.PROD_LOT_NO },
        {
            name: "MRP(₹)",
            selector: (row) =>
                (Math.round(row.MASK_PRODUCT_MRP * 100) / 100).toLocaleString("en-US"),
        },
        {
            name: "Product Price(₹)",
            selector: (row) =>
                (Math.round(row.PROD_PRICE * 100) / 100).toLocaleString("en-US"),
        },
        {
            name: "Extented Price(₹)",
            selector: (row) =>
                (Math.round(row.EXTENDED_PRICE * 100) / 100).toLocaleString("en-US"),
        },
        { name: "Order Qty", selector: (row) => row.PACK_ORD_QTY },
        { name: "Invoiced Qty", selector: (row) => row.TOT_INV_QTY },
        { name: "Release Qty", selector: (row) => row.TOT_REL_QTY },
        {
            name: "Back Qty",
            selector: (row) => Math.round((row.MASK_TOT_BACK_QTY * 100) / 100),
        },
        {
            name: "Reason",
            cell: (row) => (
                <div>
                    <select
                        className="form-select"
                        value={
                            row.MASK_TOT_BACK_QTY > 0 ? (row.RBO_REAS_CODE = "REAS/54") : null
                        }
                        // onChange={(e) => {
                        //   handleChange(e, row);
                        // }}
                        disabled={row.PACK_ORD_QTY === row.TOT_INV_QTY}
                    >
                        <option value="">Select Reason </option>
                        {reasonDetails.map((res) =>
                            res.CODE === "REAS/50" ||
                                res.CODE === "REAS/52" ||
                                res.CODE === "REAS/53" ||
                                res.CODE === "REAS/57" ? (
                                    <option
                                        value={res.CODE}
                                        key={res.CODE}
                                        disabled
                                        style={{ background: "#dddddd" }}
                                    >
                                        {res.NAME}{" "}
                                    </option>
                                ) : (
                                    <option value={res.CODE} key={res.CODE}>
                                        {res.NAME}{" "}
                                    </option>
                                )
                        )}
                    </select>
                </div>
            ),
        },
        {
            name: "Action",

            cell: (row) => (
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Edit"
                    >
                        <button
                            className={
                                row.PACK_ORD_QTY === row.TOT_INV_QTY
                                    ? "grid-icon-secondary grid-icon"
                                    : "grid-icon"
                            }
                            onClick={() => {
                                handleEdit(ref, row);
                                filterRow(row);
                            }}
                            disabled={row.PACK_ORD_QTY === row.TOT_INV_QTY}
                        >
                            <Fa.FaPencilAlt />
                        </button>
                    </div>
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="delete"
                    >
                        <button
                            className="grid-icon"
                            onClick={() => handleDeletecart1(row)}
                        >
                            <Fa.FaTrashAlt />
                        </button>
                    </div>
                </div>
            ),
        },
    ];
    const EmptyMsgPdt = () => {
        if (capital.length > 0) {
            return "No data found";
        } else {
            return "Please select any customer";
        }
    };

    if (loading) {
        return <Loader />;
    } else {
        return (
            <main>
                {/* <div className="content-wrapper pt-1"> */}
                <div className="sales-header">
                    <div className="row">
                        <div className="col-lg-1 col-md-1 col-sm-12">
                            {orientation === "portrait-primary" && (
                                <a
                                    href="#"
                                    className="sidebar-toggle"
                                    data-toggle="push-menu"
                                    role="button"
                                >
                                    <Fa.FaBars />
                                </a>
                            )}
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            <div className="invoice-num">
                                {/* {invoiceNo !== 0 && (
                    <div className="invoice-num">
                      Invoice <span>{invoiceNo}</span> created successfully
                    </div>
                  )} */}
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-7 col-sm-12">
                            <div className="float-end">
                                {/* {disableAutoAllocate &&
                    cartVal
                      .map((a) => Number(a.TOT_INV_QTY))
                      .reduce((a, b) => a + b) === 0 &&
                    cartVal
                      .map((a) => Number(a.TOT_REL_QTY))
                      .reduce((a, b) => a + b) === 0 && ( */}
                                {/* )} */}
                                <button
                                    type="submit"
                                    className="btn btn-outline-primary me-3"
                                    onClick={() => {
                                        nav("/salesmanagement/salesorder");
                                    }}
                                >
                                    <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                                    Records
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={() => {
                                        if (
                                            Array.isArray(cartVal) &&
                                            cartVal.some((val) => Number(val.PROD_PRICE) < 0)
                                        ) {
                                            toast.error("Price of product is zero or negative.", {
                                                position: toast.POSITION.TOP_CENTER,
                                                pauseOnFocusLoss: false,
                                                closeButton: false,
                                                autoClose: 2000,
                                            });
                                        } else if (
                                            Array.isArray(custInfo) &&
                                            custInfo.some((val) => val?.MASK_TAX_AREA_ID == "NA")
                                        ) {
                                            toast.error(
                                                "Tax for the customer is not defined hence billing cannot be done.",
                                                {
                                                    position: toast.POSITION.TOP_CENTER,
                                                    pauseOnFocusLoss: false,
                                                    closeButton: false,
                                                    autoClose: 2000,
                                                }
                                            );
                                        } else if (
                                            creditDetails?.length === 1 &&
                                            Number(creditDetails[0].AvailCrLimit) === 0
                                        ) {
                                            setShowPopUpMsg(
                                                "Available credit is ₹0 for the selected customer"
                                            );
                                            setShowPopUp1(true);
                                        } else if (
                                            creditDetails2?.length === 1 &&
                                            Number(creditDetails2[0].CUST_CREDIT_LIMIT) <
                                            Number(creditDetails[0].AvailCrLimit)
                                        ) {
                                            setShowPopUpMsg(
                                                "Available credit limit is more than the credit limit for this customer"
                                            );
                                            setShowPopUp1(true);
                                        } else {
                                            setSwitchUpdate(false);
                                            getSalesOrderDetails();
                                        }
                                    }}
                                    disabled={kycdisabled}
                                >
                                    Save Allocation
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fix-panel">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/salesmanagement/salesorder">Sales Orders</Link>
                            </li>
                            <li className="breadcrumb-item active">Create Sales Order</li>
                        </ol>
                    </nav>
                    <div className="stepper mt-3">
                        <ul className="nav nav-tabs">
                            <li className={customer ? "completed manualSO" : "manualSO"}>
                                <a className="" href="#stepper-step-1">
                                    <span className="round-tab">1</span>
                                    <div className="s-text">
                                        <Ci.CiViewList className="s-icon" /> Customer Details
                                    </div>
                                </a>
                            </li>
                            <li className={product ? "completed manualSO" : "disable"}>
                                <a className="" href="#stepper-step-2">
                                    <span className="round-tab">2</span>

                                    <div className="s-text1">
                                        <Ci.CiSettings className="s-icon" /> Product Details
                                    </div>
                                </a>
                            </li>
                            <li className={addToCart ? "completed manualSO" : "disable"}>
                                <a className="" href="#stepper-step-2">
                                    <span className="round-tab">3</span>

                                    <div className="s-text3">
                                        <Ci.CiShoppingCart className="s-icon" /> Add to
                                        Cart/Reallocate
                                    </div>
                                </a>
                            </li>
                            <li className="manualSO">
                                <a className="" href="#stepper-step-3">
                                    <span className="round-tab">4</span>

                                    <div className="s-text2">
                                        <Ci.CiFloppyDisk className="s-icon" /> Save Allocation
                                    </div>
                                </a>
                            </li>
                            {/* <li className="manualSO">
                                    <a className="" href="#stepper-step-3">
                                        <span className="round-tab">5</span>

                                        <div className="s-text3">
                                            <Ci.CiMemoPad className="s-icon" /> Invoice
                                        </div>
                                    </a>
                                </li> */}
                        </ul>
                    </div>
                </div>
                <div className="manual-so-content">
                    <Accordion defaultActiveKey="0" className="mb-4">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header x> Customer Details</Accordion.Header>
                            <Accordion.Body>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">
                                                Customer Name <span className="mandatory">*</span>
                                            </label>
                                            <div className="d-block">
                                                <AutoComplete
                                                    value={capital}
                                                    suggestions={capitalSuggestions}
                                                    completeMethod={filterCapitals}
                                                    onChange={(e) => handleChange(e)}
                                                    dropdown={true}
                                                    showEmptyMessage={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Sales Order Date</label>
                                            <field className="form-control">{currentDate}</field>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Sales Order Number</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                // placeholder="Sales Order No"
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Warehouse</label>
                                            <select
                                                className="form-control"
                                                aria-label="Default select example"
                                                disabled
                                            >
                                                <option selected>{defWh.value}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Payment Term</label>
                                            <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                onChange={(e) => setPayTerm(e.target.value)}
                                            >
                                                {custInfo?.length === 1 ? (
                                                    <>
                                                        <option
                                                            value={custInfo[0].MASK_PAY_TERM_ID}
                                                            selected
                                                        >
                                                            {custInfo[0].MASK_PAY_TERM_DESC}
                                                        </option>
                                                        {getPayTerm
                                                            .filter(
                                                                (res) =>
                                                                    res.MASK_PAY_TERM_ID !==
                                                                    custInfo[0].MASK_PAY_TERM_ID
                                                            )
                                                            .map((res) => {
                                                                return (
                                                                    <option
                                                                        value={res.MASK_PAY_TERM_ID}
                                                                        key={res.MASK_PAY_TERM_ID}
                                                                    >
                                                                        {res.DESCRIPTION}
                                                                    </option>
                                                                );
                                                            })}
                                                    </>
                                                ) : (
                                                    <>
                                                        <option value="1">Select One</option>
                                                        {getPayTerm.map((res) => {
                                                            return (
                                                                <option
                                                                    value={res.MASK_PAY_TERM_ID}
                                                                    key={res.MASK_PAY_TERM_ID}
                                                                >
                                                                    {res.DESCRIPTION}
                                                                </option>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Mode Of Payment</label>
                                            <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                onChange={(e) => setMopId(e.target.value)}
                                            >
                                                {custInfo?.length === 1 ? (
                                                    <>
                                                        <option value={custInfo[0].MASK_MOP_ID} selected>
                                                            {custInfo[0].MASK_MOP_DESC}
                                                        </option>
                                                        {getMOP
                                                            .filter(
                                                                (res) =>
                                                                    res.MASK_MOP_ID !== custInfo[0].MASK_MOP_ID
                                                            )
                                                            .map((res) => {
                                                                return (
                                                                    <option
                                                                        value={res.MASK_MOP_ID}
                                                                        key={res.MASK_MOP_ID}
                                                                    >
                                                                        {res.DESCRIPTION}
                                                                    </option>
                                                                );
                                                            })}
                                                    </>
                                                ) : (
                                                    <>
                                                        <option value="1">Select One</option>
                                                        {getMOP.map((res) => {
                                                            return (
                                                                <option
                                                                    value={res.MASK_MOP_ID}
                                                                    key={res.MASK_MOP_ID}
                                                                >
                                                                    {res.DESCRIPTION}
                                                                </option>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Sales Executive</label>
                                            <select
                                                className="form-select"
                                                aria-label="Default select example"
                                            >
                                                {custInfo?.length === 1 ? (
                                                    <>
                                                        <option value={custInfo[0].EMP_ID} selected>
                                                            {custInfo[0].MASK_EMP_NAME}
                                                        </option>
                                                        {getSalesExecutive
                                                            .filter(
                                                                (res) => res.NAME !== custInfo[0].MASK_EMP_NAME
                                                            )
                                                            .map((res) => {
                                                                return (
                                                                    <option
                                                                        value={res.MASK_EMP_ID}
                                                                        key={res.MASK_EMP_ID}
                                                                    >
                                                                        {res.NAME}
                                                                    </option>
                                                                );
                                                            })}
                                                    </>
                                                ) : (
                                                    <>
                                                        <option value="1">Select One</option>
                                                        {getSalesExecutive.map((res) => {
                                                            return (
                                                                <option
                                                                    value={res.MASK_EMP_ID}
                                                                    key={res.MASK_EMP_ID}
                                                                >
                                                                    {res.NAME}
                                                                </option>
                                                            );
                                                        })}
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Customer PO Number</label>
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="Customer PO Number"
                                                onChange={(e) => setCustPONo(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Trade Discount</label>
                                            <input
                                                className="form-control"
                                                value={tradeDisc}
                                                type="number"
                                                placeholder="Trade Discount"
                                                onChange={(e) => {
                                                    const regex = /^\d{0,2}(\.\d{0,2})?$/;
                                                    if (
                                                        regex.test(e.target.value) ||
                                                        e.target.value === ""
                                                    ) {
                                                        setTradeDisc(e.target.value);
                                                    }
                                                }}

                                            // onChange={(e)=>setTradeDisc(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label">Remarks</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                placeholder="This is where you will leave remarks about the customers order on InnoRise..."
                                                onChange={(e) => setRemarks(e.target.value)}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="card px-3 py-3 mb-3">
                                    <h4>Shipping Address</h4>
                                    <div className="row">
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Address Line 1</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        custInfo?.length === 1
                                                            ? custInfo[0].CSHIP_ADD1
                                                            : "Address Line 1"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Address Line 2</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        custInfo?.length === 1
                                                            ? custInfo[0].CSHIP_ADD2
                                                            : "Address Line 2"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Town</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        custInfo?.length === 1
                                                            ? custInfo[0].BILL_TOWN
                                                            : "Town"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card px-3 py-3 mb-3">
                                    <h4>Credit Position</h4>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Credit Limit Set</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Credit Limit Set"
                                                    value={
                                                        creditDetails2?.length === 1
                                                            ? creditDetails2[0].CUST_CREDIT_LIMIT
                                                            : "Credit Limit Set"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Closing balance</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails?.length === 1
                                                            ? creditDetails[0].ClosingBalance
                                                            : "Closing balance"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Cheques in Hand</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails?.length === 1
                                                            ? creditDetails[0].ChkInHand
                                                            : "Cheques in Hand"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Net Balance</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails?.length === 1
                                                            ? creditDetails[0].NetBalance
                                                            : "Net Balance"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Max Order Value</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails2?.length === 1
                                                            ? creditDetails2[0].CUST_MAX_ORDER_VAL
                                                            : "Max Order Value"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Min Order Value</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails2?.length === 1
                                                            ? creditDetails2[0].CUST_MIN_ORDER_VAL
                                                            : "Min Order Value"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">Credit Limit Used</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder="Credit Limit Used"
                                                    value={
                                                        creditDetails2?.length === 1 &&
                                                            creditDetails?.length === 1
                                                            ? Math.round(
                                                                (creditDetails2[0].CUST_CREDIT_LIMIT -
                                                                    creditDetails[0].AvailCrLimit) *
                                                                100
                                                            ) / 100
                                                            : "Credit Limit Used"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Available Credit Limit
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={
                                                        creditDetails?.length === 1
                                                            ? creditDetails[0].AvailCrLimit
                                                            : "Available Credit Limit"
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        {
                            <Accordion.Item eventKey="1" className="mt-2">
                                <Accordion.Header x> Product Details</Accordion.Header>
                                <Accordion.Body>
                                    {auth.BasketApplicability == "Y" && (
                                        <div className="d-inline-flex pb-3">
                                            <div className="flex align-items-center me-3">
                                                <RadioButton
                                                    name="Product"
                                                    value="Product"
                                                    onChange={() => setPdtType("Product")}
                                                    checked={pdtType === "Product"}
                                                />
                                                <label className="ms-2">Product</label>
                                            </div>
                                            <div className="flex align-items-center">
                                                <div className="flex align-items-center">
                                                    <RadioButton
                                                        name="Basket"
                                                        value="Basket"
                                                        onChange={() => setPdtType("Basket")}
                                                        checked={pdtType === "Basket"}
                                                    />
                                                    <label className="ms-2">Basket</label>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="card">
                                        {pdtType === "Product" && (
                                            <div className="row product_panel">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Product <span className="mandatory">*</span>
                                                        </label>
                                                        <div className="d-block">
                                                            <AutoComplete
                                                                // multiple={true}
                                                                value={suggestedProductList}
                                                                suggestions={filterProductList}
                                                                completeMethod={filterProduct}
                                                                onChange={(e) => handleProd(e)}
                                                                dropdown={true}
                                                                forceSelection
                                                                showEmptyMessage={true}
                                                                disabled={kycdisabled}
                                                                emptyMessage={EmptyMsgPdt()}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Ordered Quantity
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            value={orderQty}
                                                            type="number"
                                                            onKeyDown={blockInvalidChar}
                                                            placeholder="Ordered Quantity"
                                                            onChange={(e) => setOrderQty(e.target.value)}
                                                            disabled={kycdisabled}
                                                            onWheel={(e) => e.target.blur()}
                                                            min="0"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Release Quantity
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            value={releaseQty}
                                                            type="number"
                                                            onKeyDown={blockInvalidChar}
                                                            placeholder="Release Quantity"
                                                            onChange={(e) => setReleaseQty(e.target.value)}
                                                            disabled={kycdisabled}
                                                            onWheel={(e) => e.target.blur()}
                                                            min="0"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {pdtType === "Basket" && (
                                            <div className="row basket_panel">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Basket <span className="mandatory">*</span>
                                                        </label>
                                                        <div className="d-block">
                                                            <AutoComplete
                                                                field="BASKET_NAME"
                                                                value={onchangebasketname}
                                                                suggestions={basketname}
                                                                completeMethod={searchBasket}
                                                                onChange={(e) => {
                                                                    handleBasketprod(e);
                                                                }}
                                                                dropdown={true}
                                                                forceSelection
                                                                itemTemplate={baksetTemplate}
                                                                emptyMessage="No basket data found"
                                                                showEmptyMessage
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Ordered Quantity
                                                        </label>
                                                        <input
                                                            className="form-control"
                                                            value={basketQty}
                                                            type="number"
                                                            onKeyDown={blockInvalidChar}
                                                            placeholder="Ordered Quantity"
                                                            onChange={(e) => setBasketQty(e.target.value)}
                                                            disabled={kycdisabled}
                                                            onWheel={(e) => e.target.blur()}
                                                            min="0"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        <div className="row btn_panel">
                                            {pdtType === "Product" && (
                                                <div className="col-lg-8 col-md-8 col-sm-12">
                                                    {prodRow && (
                                                        <div className="lot-panel">
                                                            <div className="d-inline info-text col">
                                                                <p>
                                                                    <Fa.FaRegFileAlt /> Lot Number{" "}
                                                                    <span>{prodRow[0]?.PROD_BATCH_NO}</span>{" "}
                                                                </p>
                                                            </div>
                                                            <div className="d-inline info-text col">
                                                                <p>
                                                                    <Fa.FaRegBookmark /> Unit Price :{" "}
                                                                    <span>
                                                                        {Number(calculatePrice).toLocaleString(
                                                                            "en-IN",
                                                                            { style: "currency", currency: "INR" }
                                                                        )}
                                                                    </span>{" "}
                                                                </p>
                                                            </div>
                                                            <div className="d-inline info-text col">
                                                                <p>
                                                                    <Fa.FaRegCheckSquare /> Available Quantity :{" "}
                                                                    <span>{prodRow[0]?.STOCK_AVAILABLE}</span>{" "}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {pdtType === "Basket" && (
                                                <div className="col-lg-8 col-md-8 col-sm-12">
                                                    {onchangebasketname && (
                                                        <div className="lot-panel w-50">
                                                            <div className="d-inline info-text col">
                                                                <p>
                                                                    <Fa.FaRegFileAlt /> Basket Price :{" "}
                                                                    <span>{basketPrice}</span>{" "}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            <div className="col-lg-4 col-md-4 col-sm-12">
                                                <div className="float-end">
                                                    {pdtType === "Product" && (
                                                        <button
                                                            type="submit"
                                                            className="btn btn-outline-primary me-3"
                                                            onClick={handlemanualreallocate}
                                                            disabled={kycdisabled}
                                                        >
                                                            Reallocate
                                                        </button>
                                                    )}
                                                    {pdtType === "Product" ? (
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary me-3"
                                                            onClick={addtocart}
                                                            disabled={kycdisabled}
                                                        >
                                                            Add to Cart
                                                        </button>
                                                    ) : (
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary me-3"
                                                            onClick={basketaddtocart}
                                                            disabled={kycdisabled}
                                                        >
                                                            Add to Cart
                                                        </button>
                                                    )}
                                                    <button
                                                        type="submit"
                                                        className="btn btn-cancel-red"
                                                        onClick={handleReset}
                                                        disabled={kycdisabled}
                                                    >
                                                        Reset
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {orderSummary && (
                                        <div className="card mt-3">
                                            <div className="row order-summery">
                                                <div className="col-lg-4 col-md-12 col-sm-12">
                                                    <h3> Sales Order Summary</h3>
                                                    {/* {prodRow && (
                                                            <p className="float-end">
                                                                {prodRow[0].DESCRIPTION}
                                                            </p>
                                                        )} */}
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className=" order-detail-container">
                                                        <div className="order-box1">Net Volume (Ltr): </div>
                                                        <div className="order-box text-end">
                                                            <span>{volume}</span>
                                                        </div>
                                                    </div>
                                                    <div className=" order-detail-container">
                                                        <div className="order-box1">Net Weight (kg):</div>
                                                        <div className="order-box text-end">
                                                            <span>{weight}</span>
                                                        </div>
                                                    </div>
                                                    <hr className="borderMobileView"></hr>
                                                    <div className=" order-detail-container">
                                                        <div className="order-box1">Gross Value:</div>
                                                        <div className="order-box text-end">
                                                            <span>
                                                                ₹{" "}
                                                                {cartVal.length > 0
                                                                    ? cartVal
                                                                        .map((a) => Number(a.BASE_PRICE))
                                                                        .reduce((a, b) => a + b)
                                                                        .toFixed(2)
                                                                    : "0.00"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className="order-detail-container ps-4">
                                                        <div className="order-box">Amount Before Tax: </div>
                                                        <div className="order-box text-end">
                                                            <span>
                                                                ₹{" "}
                                                                {cartVal.length > 0
                                                                    ? (
                                                                        cartVal
                                                                            .map((a) => Number(a.BASE_PRICE))
                                                                            .reduce((a, b) => a + b) -
                                                                        cartVal
                                                                            .map((a) => Number(a.CDR_DISC))
                                                                            .reduce((a, b) => a + b) -
                                                                        cartVal
                                                                            .map((a) => Number(a.EUS_DISC))
                                                                            .reduce((a, b) => a + b) -
                                                                        cartVal
                                                                            .map((a) => Number(a.MASK_TRADE_DISC))
                                                                            .reduce((a, b) => a + b)
                                                                    ).toFixed(2)
                                                                    : "0.00"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="order-detail-container ps-4 border-bottom">
                                                        <div className="order-box">GST Amount:</div>
                                                        <div className="order-box text-end">
                                                            <span>
                                                                ₹{" "}
                                                                {cartVal.length > 0
                                                                    ? cartVal
                                                                        .map((a) => Number(a.MASK_SODT_TOT_VAT))
                                                                        .reduce((a, b) => a + b)
                                                                        .toFixed(2)
                                                                    : "0.00"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="total order-detail-container ps-4">
                                                        <div className="order-box ">Total Amount: </div>
                                                        <div className="order-box text-end">
                                                            <span className="">
                                                                ₹{" "}
                                                                {/* {cartVal.length > 0 ? ((
                                                                    (
                                                                        (cartVal
                                                                            .map((a) => Number(a.BASE_PRICE))
                                                                            .reduce((a, b) => a + b) -
                                                                                cartVal
                                                                                    .map((a) => Number(a.CDR_DISC))
                                                                                    .reduce((a, b) => a + b) -
                                                                                cartVal
                                                                                    .map((a) => Number(a.EUS_DISC))
                                                                                    .reduce((a, b) => a + b) -
                                                                                cartVal
                                                                                    .map((a) => Number(a.MASK_TRADE_DISC))
                                                                                    .reduce((a, b) => a + b) +
                                                                                (cartVal
                                                                                    .map((a) =>
                                                                                        Number(a.MASK_SODT_TRANS_VAL)
                                                                                    )
                                                                                    .reduce((a, b) => a + b) +
                                                                                    cartVal
                                                                                        .map((a) => Number(a.MASK_TOT_TAX))
                                                                                        .reduce((a, b) => a + b) +
                                                                                    cartVal
                                                                                        .map((a) =>
                                                                                            Number(a.MASK_SODT_TOT_VAT)
                                                                                        )
                                                                                        .reduce((a, b) => a + b))).toFixed(2)
                                                                    )
                                                                )) : "0.00"} */}
                                                                {cartVal.length > 0
                                                                    ? parseFloat(
                                                                        cartVal
                                                                            .reduce(
                                                                                (sum, item) =>
                                                                                    sum +
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(item.BASE_PRICE) || 0
                                                                                        ).toFixed(2)
                                                                                    ) -
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(item.CDR_DISC) || 0
                                                                                        ).toFixed(2)
                                                                                    ) -
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(item.EUS_DISC) || 0
                                                                                        ).toFixed(2)
                                                                                    ) -
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(
                                                                                                item.MASK_TRADE_DISC
                                                                                            ) || 0
                                                                                        ).toFixed(2)
                                                                                    ) +
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(
                                                                                                item.MASK_SODT_TRANS_VAL
                                                                                            ) || 0
                                                                                        ).toFixed(2)
                                                                                    ) +
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(item.MASK_TOT_TAX) ||
                                                                                            0
                                                                                        ).toFixed(2)
                                                                                    ) +
                                                                                    parseFloat(
                                                                                        (
                                                                                            parseFloat(
                                                                                                item.MASK_SODT_TOT_VAT
                                                                                            ) || 0
                                                                                        ).toFixed(2)
                                                                                    ),
                                                                                0
                                                                            )
                                                                            .toFixed(2)
                                                                    )
                                                                    : "0.00"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        }
                    </Accordion>
                    <div className="grid sales-order-details mb-4">
                        {manualSOLoader ? (
                            <Loader />
                        ) : (
                            <DataTable
                                columns={column}
                                data={cartVal}
                                pagination
                                fixedHeader
                                fixedHeaderScrollHeight="400px"
                                selectableRowsHighlight
                                highlightOnHover
                                conditionalRowStyles={conditionalRowStylesBasket}
                                subHeaderAlign="right"
                            />
                        )}
                    </div>
                    {/* {reallocloader?<Loader/>:<ReallocateModal data={filteredSalesDetails} column={column} />} */}
                    <ReallocateModal data={filteredSalesDetails} column={column} />
                    {invoicePopup ? <Print /> : null}
                    <div>
                        {/* You can conditionally render the ShowPopUp dialog */}
                        {showPopUp && popUpDialog()}
                        {showPopUp1 && popUpDialogforSave()}
                    </div>
                </div>
                {/* </div> */}
            </main>
        );
    }
}

export default CreateSOOrder;
